import {Goal} from '../../goals/_interfaces/goal.interface';
import {AttributeItem} from '../../users/_interfaces/users-admin';
import {GoalTypeEnum} from '../enums/GoalTypeEnum';
import {GlobalizationConfig} from './globalization-config.interface';

export interface ProcessPreview {
    cycleId: number;
    cycleParticipantId: number;
    cycleParticipantStepId: number;
    cycleProcessConfigId: number;
    processId: number;
    processType: ProcessTypeEnum;
    title: GlobalizationConfig;
    consentGoalsGlobalizationConfig: GlobalizationConfig;
    consentGoals: Goal[];
    consentAttributes: AttributeItem[];
    goalType: GoalTypeEnum;
    startsAt: Date;
    startsAtString: string;
    endsAt: Date;
    endsAtString: string;
    status: ProcessStatusEnum;
    obs?: string;
    showOnUserProcessList: boolean;
    anonymousReport: boolean;
}

export enum ProcessTypeEnum {
    GoalInputs = 1,
    GoalInputValidation = 2,
    FreeEvaluationMidYear = 3,
    TwoPlusTwoCoaching = 4,
    GoalsReview = 5,
    TwoPlusTwoCoachingValidation = 6,
    GoalsReviewValidation = 7,
    ThreeSixtyEvaluatorsSelection = 8,
    ThreeSixtyEvaluatorsValidation = 9,
    ThreeSixtyEvaluation = 10,
    FreeEvaluationEndYear = 11,
    SelfEvaluation = 12,
    ManagerEvaluation = 13,
    EvaluationCalibration = 14,
    EvaluationValidation = 15,
    FinalResult = 16,
    FinalFeedback = 17,
    SelfEvaluationMidYear = 18,
    GenericProcess = 19,
    HeadEvaluation = 20,
    FinalFeedbackValidation = 21,
}

export enum ProcessStatusEnum {
    NotEnabled = 0,
    WaitingInput = 1,
    Declined = 2,
    AllowedViewing = 3,
    AllowedViewingWithWarnings = 4
}

export enum CalibrationTypeEnum {
    ForcedCurve = 1,
    Matrix = 2,
    Both = 3,
}